/// <reference types="@angular/localize" />
import { enableProdMode } from '@angular/core';
import * as WebFont from 'webfontloader';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { createSphereAppConfig } from './app/sphere-app.config';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { AppConfiguration } from '@sphere/platform';
import { SphereComponent } from './app/sphere.component';

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(environment.agGrid?.license);

loadAppConfig().then((config: AppConfiguration) => {
    /* If environment is set to production, DEBUG logging is disabled */
    if (environment.production) {
        console.debug = (value: any): void => null;
    }

    if (environment.production) {
        enableProdMode();
    }

    bootstrapApplication(SphereComponent, createSphereAppConfig(config)).catch(err => console.log(err));
});

WebFont.load({
    google: {
        families: ['Roboto:300,400,500,italic', 'Inter:100,200,300,400,500,600,700,800,900,ital', 'Material+Icons', 'Material+Symbols+Outlined']
    }
});

async function loadAppConfig() {
    console.debug(`fetching app config...`);
    const response = await fetch('assets/app-config.json');
    if (response.ok) {
        return (await response.json()) as AppConfiguration;
    } else {
        throw new Error(response.statusText);
    }
}
